// Tyler.Api.Metadata.ChartType
export enum ChartType {
    Pie = 1,
    Bar = 2,
    Line = 3,
    Column = 4
}
